import * as React from 'react';
import { AppUser } from 'Src/views/App/App';
import { SchoolEvent } from 'Src/models/event';
import { getEventGeneratedName } from 'Src/helpers/accessor/accessor';
import { EventReadOnlyHero } from 'Src/components/EventReadOnlyHero/EventReadOnlyHero';

interface Props {
  user: AppUser;
  event: SchoolEvent;
  isPrevButtonDisabled?: boolean;
  isNextButtonDisabled?: boolean;
  onPrevEventClick?: () => void;
  onNextEventClick?: () => void;
  onReportAvailabilityClick?: () => void;
  onViewMapClick: () => void;
}

export function StudentEventMainInformation(props: Props) {
  const { user, event } = props;
  return <EventReadOnlyHero {...props} user={user} event={event} eventName={getEventGeneratedName(event, { user })} />;
}
